/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { ChevronDownIcon } from "lucide-react"
import type { ComponentProps, FunctionComponent } from "react"

import AndroidIcon from "../../assets/images/android.svg?react"
import AppleIcon from "../../assets/images/apple.svg?react"
import type { ApplicationTypePlatform } from "../../features/application-type/application-type-types"
import { Button } from "../primitives/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "../primitives/dropdown-menu"

const PLATFORMS: { value: ApplicationTypePlatform; label: string; Icon: FunctionComponent<ComponentProps<"svg">> }[] = [
    { value: "ANDROID", label: "Android", Icon: AndroidIcon },
    { value: "APPLE", label: "Apple", Icon: AppleIcon }
]

interface Props {
    platform: ApplicationTypePlatform
    onPlatformSelected: (platform: ApplicationTypePlatform) => void
}

export const ApplicationTypePlatformDropdownView = ({ platform, onPlatformSelected }: Props) => {
    const selected = PLATFORMS.find((it) => it.value === platform)

    return (
        <DropdownMenu>
            <DropdownMenuTrigger render={<Button variant="outline" className="w-full justify-between font-normal" />}>
                {selected && <PlatformLabel {...selected} />}
                <ChevronDownIcon />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuGroup>
                    {PLATFORMS.map((it) => (
                        <DropdownMenuItem key={it.value} onClick={() => onPlatformSelected(it.value)}>
                            <PlatformLabel {...it} />
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

const PlatformLabel = ({ label, Icon }: { label: string; Icon: FunctionComponent<ComponentProps<"svg">> }) => (
    <span className="flex items-center gap-2">
        <Icon aria-hidden="true" />
        {label}
    </span>
)
